const carouselItems = [
  {
    title: '国产科幻崛起之路',
    desc: '从《流浪地球》到《三体》，国产科幻用硬核实力征服观众，开启中国科幻电影新纪元。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20futuristic%20cityscape%20and%20warm%20golden%20sunset%20lighting%2C%20grand%20space%20atmosphere%2C%20Chinese%20science%20fiction%20aesthetic%2C%20dramatic%20clouds%20and%20amber%20skies%2C%20blockbuster%20movie%20visual%2C%20high%20detail%20composition&width=800&height=500&seq=carousel-cinema-01&orientation=landscape',
    stat: '累计票房超百亿',
  },
  {
    title: '悬疑剧场：烧脑神作合集',
    desc: '层层反转，高能不断。精选全网口碑悬疑剧，从国产精品到海外神作，挑战你的推理极限。',
    image: 'https://readdy.ai/api/search-image?query=Noir%20detective%20atmosphere%20with%20dramatic%20shadows%20and%20warm%20amber%20lighting%2C%20mysterious%20cinematic%20mood%2C%20crime%20scene%20investigation%20aesthetic%2C%20film%20noir%20style%20photography%2C%20high%20contrast%20composition%2C%20high%20detail&width=800&height=500&seq=carousel-cinema-02&orientation=landscape',
    stat: '口碑评分9+',
  },
  {
    title: '家庭影院：合家欢片单',
    desc: '周末与家人共享温馨观影时光，从动画大片到温情喜剧，这份合家欢片单请收好。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20family%20living%20room%20with%20large%20TV%20screen%20and%20warm%20ambient%20lighting%2C%20comfortable%20home%20theater%20setup%2C%20golden%20evening%20atmosphere%2C%20relaxed%20family%20time%2C%20cinematic%20home%20decor%2C%20warm%20tone%20photography%2C%20high%20detail&width=800&height=500&seq=carousel-cinema-03&orientation=landscape',
    stat: '全年龄段推荐',
  },
  {
    title: '高分纪录片：用镜头看世界',
    desc: '自然、人文、历史、科技——高分纪录片带你足不出户探索世界，每一帧都是视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%20with%20golden%20hour%20landscape%2C%20warm%20sunlight%20over%20vast%20wilderness%2C%20cinematic%20aerial%20photography%2C%20rich%20amber%20and%20earth%20tones%2C%20planet%20earth%20aesthetic%2C%20high%20detail%20composition&width=800&height=500&seq=carousel-cinema-04&orientation=landscape',
    stat: '豆瓣均分8.5+',
  },
  {
    title: '经典港片回忆杀',
    desc: '重温那些年的港片黄金时代，从周星驰喜剧到警匪经典，一场关于青春与情怀的光影之旅。',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20cinema%20aesthetic%20with%20neon%20signs%20and%20warm%20vintage%20lighting%2C%20nostalgic%20film%20atmosphere%2C%20old%20school%20movie%20poster%20style%2C%20golden%20era%20Hong%20Kong%20street%20scene%2C%20warm%20amber%20and%20coral%20tones%2C%20high%20detail&width=800&height=500&seq=carousel-cinema-05&orientation=landscape',
    stat: '经典永不过时',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-sparkling-2-line"></i>重磅专题
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">焦点专题推荐</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选五大影视专题，带你深度探索好内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.slice(0, 3).map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`51影院专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 mb-2 whitespace-nowrap">{item.stat}</span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 leading-snug">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {carouselItems.slice(3, 5).map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer flex flex-col sm:flex-row md:col-span-2 lg:col-span-3">
              <div className="sm:w-[40%] lg:w-[30%] aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`51影院专题 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 mb-2 whitespace-nowrap self-start">{item.stat}</span>
                <h3 className="font-heading text-lg md:text-xl text-foreground-900 mb-2 leading-snug">{item.title}</h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}